var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":"","cols":"12"}},[_c('v-col',{staticClass:"pr-2",attrs:{"cols":"3"}},[_vm._v(_vm._s(_vm.headers.header_role))]),_c('v-col',{staticClass:"pr-2",attrs:{"cols":"5"}},[_vm._v(_vm._s(_vm.headers.header_eign))]),_c('v-col',{attrs:{"cols":"4"}},[_vm._v(_vm._s(_vm.headers.header_vat))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }